type ActionHandler = (() => void) | null

let okHandler: ActionHandler = null
let cancelHandler: ActionHandler = null

export function setOkHandler(handler: ActionHandler) {
  okHandler = handler
}

export function setCancelHandler(handler: ActionHandler) {
  cancelHandler = handler
}

export function clearHandlers() {
  okHandler = null
  cancelHandler = null
}

export function triggerOk() {
  if (okHandler) okHandler()
}

export function triggerCancel() {
  if (cancelHandler) cancelHandler()
}